/**
 * Resolve a login `redirect` parameter to a same-origin path, or reject it.
 *
 * The value arrives from a query string, so it must never be able to send a
 * freshly authenticated user off-site. Prefix checks are not enough: the URL
 * parser strips ASCII tab, LF, and CR *before* parsing, so `/\t/evil.example`
 * passes a literal `//` test and still resolves to `https://evil.example`.
 * Resolving against the app's own origin and comparing the result is the only
 * check that sees what the browser will actually navigate to.
 */
export function safeInternalRedirect(value: string | undefined, origin: string): string | null {
  if (!value) return null;

  let resolved: URL;
  try {
    resolved = new URL(value, origin);
  } catch {
    return null;
  }
  if (resolved.origin !== new URL(origin).origin) return null;

  // Return the parser's own normalization, never the raw input.
  return `${resolved.pathname}${resolved.search}${resolved.hash}`;
}
